module.exports = __webpack_public_path__ + "img/07.15b48b6e.png";